import { render, staticRenderFns } from "./svipSuc.vue?vue&type=template&id=2ff3305e&scoped=true"
import script from "./svipSuc.vue?vue&type=script&lang=js"
export * from "./svipSuc.vue?vue&type=script&lang=js"
import style0 from "./svipSuc.vue?vue&type=style&index=0&id=2ff3305e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3305e",
  null
  
)

export default component.exports